export default "__VITE_ASSET__CeIUPZAn__"